import graphQLClient from 'config/graphql-instance';
import { Geometry, Location, LocationKind } from 'types/geospatial';

export type GQLSearchLocations = {
  searchLocations: Location[]
};

export const searchLocations = async (
  payload: {
    kind: LocationKind,
    name?: string,
    return?: LocationKind[]
  }
) => {
  const queryParams = payload.name ? `$kind: LocationKind!, $name: String!, $return: [LocationKind!]` : `$kind: LocationKind!, $return: [LocationKind!]`;
  const queryParamsSet = payload.name ? `kind: $kind, name: $name, return: $return` : `kind: $kind, return: $return`;
  const query = `
    query searchLocations(${queryParams}) {
    searchLocations(${queryParamsSet}) {
      _id
      name
      kind
      geometry
    }
  }
  `;
  const response = await graphQLClient()
    .request<GQLSearchLocations>(query, payload);

  return response;
};

export type MapGeometry = {
  address: string,
  geometry: Geometry,
  orders: {
    order_id: string,
    _id: string
  }[]
}

export type GQLMapOrdersResponse = {
  mapOrders: MapGeometry[]
};

export const mapOrders = async (
  payload: {
    agencyId?: string,
    status: string,
    geometryId: string
  }
) => {
  const params: string[] = [];
  const payloads: string[] = [];

  if (["closed", "open", "canceled", "hold"].includes(payload.status)) {
    params.push("$status: OrderStatuses");
    payloads.push("status: $status");
  }

  if (payload.agencyId) {
    params.push("$agencyId: String");
    payloads.push("agency_id: $agencyId");
  }

  if (payload.geometryId) {
    params.push("$geometryId: String");
    payloads.push("geometry_id: $geometryId");
  }

  const query = `
    query MapOrders ${params.length ? `(${params.join(",")})` : ""} {
      mapOrders ${payloads.length ? `(${payloads.join(",")})` : ""} {
        address
        geometry
        orders
      }
    }
  `;
  const response = await graphQLClient()
    .request<GQLMapOrdersResponse>(query, payload);

  return response;
};
